import axios from "axios";

export default axios.create({
  baseURL: "https://api.maxx247.com/api/maxxfood",
});
